"use strict";

if (document.getElementById("app_article")) {
  var vueEditArticle = new Vue({
    delimiters: ['[[', ']]'],
    el: '#app_article',
    data: {
      article: [],
      image: [],
      image_id: 0,
      eventStart: '',
      eventStart_time: '',
      eventEnd: '',
      eventEnd_time: '',
      attachments: [],
      videoURL: '',
      categories: []
    },
    mounted: function mounted() {
      $.ajaxSetup({
        traditional: true
      });
    },
    methods: {
      getArticleCategories: function getArticleCategories() {
        var params = [],
            article = vueEditArticle.article,
            cat = vueEditArticle.article.category;

        if (article.is_public) {
          params.push('public');
        }

        if (article.is_private) {
          params.push('private');
        }

        if (!params.length) {
          vueEditArticle.categories = [];
          return;
        }

        var urlApi = '/api/v1/categories_articles?display=' + params.join('-');
        $.ajax({
          url: urlApi,
          method: 'GET',
          headers: {
            'Accept-Language': languageCode
          },
          success: function success(response) {
            var categories = response.results;
            vueEditArticle.categories = categories;
            var found = categories.find(function (r) {
              return r.id == cat;
            });

            if (!found) {
              vueEditArticle.article.category = !categories.length ? null : categories[0].id;
            }
          },
          error: function error(_error) {
            console.log(_error);
          }
        });
      },
      getArticle: function getArticle(id) {
        var urlApi = '/api/v1/articles/' + id;
        $.ajax({
          url: urlApi,
          method: 'GET',
          headers: {
            'Accept-Language': languageCode
          },
          success: function success(response) {
            $('.js-add-attachment-article').removeClass('disabled');
            $('.js-add-attachment-article').openModal();
            var image_id = response.image;

            if (image_id) {
              vueEditArticle.getImage(image_id);
            }

            vueEditArticle.article = response;

            if (response.video_id) {
              vueEditArticle.videoURL = 'https://www.youtube.com/watch?v=' + response.video_id;
            }

            vueEditArticle.getArticleCategories();
            CKEDITOR.replace('content', {
              customConfig: confCKeditorBlog
            });
            setTimeout(function () {
              vueEditArticle.eventStart = $('#event_start').val().substring(0, 10);
              vueEditArticle.eventStart_time = $('#event_start').val().substring(11, 16);
              vueEditArticle.eventEnd = $('#event_end').val().substring(0, 10);
              vueEditArticle.eventEnd_time = $('#event_end').val().substring(11, 16);
              inputTags();
              $('.js-category-radio').chooseCategory();
              $('.js-youtube-input').videoID();
              $('.js-groups-checkboxes').initGroupsArticles();
              $('.js-tag').find('.js-close').removeTag();
              vueEditArticle.getAttachments();
              vueEditArticle.deleteArticle();
            }, 500);
          },
          error: function error(_error2) {
            console.log(_error2);
          }
        });
      },
      deleteArticle: function deleteArticle() {
        var deleteBtn = $('.js-delete-article');
        deleteBtn.on('click', function (e) {
          e.preventDefault();
          var id = $(this).data('id'),
              urlArticles = $(this).data('url');
          $.ajax({
            url: '/api/v1/articles/' + id,
            type: 'DELETE',
            success: function success(response) {
              console.log(response);
              window.location.href = urlArticles;
            },
            error: function error(_error3) {
              console.log(_error3);
            }
          });
        });
      },
      getImage: function getImage(id) {
        var urlApi = '/api/v1/medias/' + id;
        $.ajax({
          url: urlApi,
          method: 'GET',
          success: function success(response) {
            vueEditArticle.image_id = response.id;
          },
          error: function error(_error4) {
            console.log('No images for this article');
          }
        });
      },
      getAttachments: function getAttachments() {
        var content_type = $('.js-article').attr('data-content-type');
        var urlApi = '/api/v1/attachments?editing=1&content_type=' + content_type + '&object_id=' + $('.js-article').data('id');
        $.ajax({
          url: urlApi,
          method: 'GET',
          success: function success(response) {
            vueEditArticle.attachments = response.results;
            setTimeout(function () {
              vueEditArticle.deleteAttachment();
            }, 500);
          },
          error: function error(_error5) {
            console.log(_error5);
          }
        });
      },
      allowAttachments: function allowAttachments() {
        var inputs = $('[data-error]').find('input:not(.input-modal)');
        validate();
        inputs.on('change input keyup', validate);

        function validate() {
          var inputLength = 0;
          inputs.each(function () {
            $(this).val() == '' ? inputLength-- : inputLength++;
          });
          inputLength >= inputs.length ? notEmpty() : isEmpty();
        }

        function notEmpty() {
          $('.js-add-attachment-article').removeClass('disabled');
          $('.js-add-attachment-article').openModal();
        }

        function isEmpty() {
          $('.js-add-attachment-article').addClass('disabled');
          $('.js-add-attachment-article').unbind();
        }
      },
      typeAttachment: function typeAttachment() {
        var select = $('.js-form-upload').find('.js-select');
        select.on('change', function () {
          if ($(this).find('option:selected').data('slug') !== 'videos' && $(this).find('option:selected').data('slug') !== 'video') {
            var $target = $('[data-tab="tab_1"]'),
                $currentItem = $('.js-tab-toggle[data-target="1"]');
            $('.js-tab-toggle[data-target="2"]').removeClass('active').hide();
            $currentItem.addClass('active').show();
            $('.js-tab-item').find('input').attr('required', false);
            $target.find('input').attr('required', true);
            setTimeout(function () {
              $('.js-tab-item').hide();
              $target.show();
              setTimeout(function () {
                $target.addClass('left');
                $target.addClass('active').removeClass('left right');
              }, 50);
            }, 150);
            $('.js-underline').css({
              'width': $currentItem.width()
            });
          } else {
            var $target = $('[data-tab="tab_2"]'),
                $currentItem = $('.js-tab-toggle[data-target="2"]');
            $('.js-tab-item').find('input').attr('required', false);
            $target.find('input').attr('required', true);
            $currentItem.addClass('active').show();
            $('.js-tab-toggle[data-target="1"]').removeClass('active').hide();
            $currentItem.css({
              'padding-left': 0
            });
            $('.js-underline').css({
              'width': $currentItem.width(),
              'left': $currentItem.position().left
            });
            setTimeout(function () {
              $('.js-tab-item').hide();
              $target.show();
              setTimeout(function () {
                $target.addClass('right');
                $target.addClass('active').removeClass('left right');
              }, 50);
            }, 150);
          }
        });
      },
      addAttachment: function addAttachment() {
        var input = $('#uploadAttachment').find('.js-attachment-input'),
            filename = $('#uploadAttachment').find('.js-filename'),
            fileData = '';
        input.on('change', function (e) {
          var fileName = e.target.files[0].name;
          fileData = $(this)[0].files[0];
          filename.text(fileName);
        });
      },
      deleteAttachment: function deleteAttachment() {
        var deleteBtn = $('.js-delete-attachment');
        deleteBtn.on('click', function () {
          var id = $(this).data('id');
          var attachment = $(this).parent().parent();
          $.ajax({
            url: '/api/v1/attachments/' + id,
            type: 'DELETE',
            success: function success(response) {
              attachment.remove();
            },
            error: function error(_error6) {
              console.log(_error6);
            }
          });
        });
      }
    }
  });
  var postID = $('.js-article').data('id');

  if (!$('.js-form-article').hasClass('js-create-article')) {
    vueEditArticle.getArticle(postID);
  } else {
    vueEditArticle.allowAttachments();
    CKEDITOR.replace('content', {
      customConfig: confCKeditorBlog
    });
  }
}

(function ($) {
  $.fn.updateArticle = function () {
    $('#lawyer_image').on('change', function () {
      var formData = new FormData($('.js-form-article'));
      formData.append('image', $(this)[0].files[0]);
      formData.append('attachment', $(this)[0].files[0]);
      formData.append("csrfmiddlewaretoken", $('[name="csrfmiddlewaretoken"]').val());
      $.ajax({
        url: '/api/v1/medias',
        type: 'POST',
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        beforeSend: function beforeSend() {
          $('.js-loader').show();
          $('.js-loader').addClass('animated');
        },
        success: function success(response) {
          $('.js-preview').css({
            'background-image': 'url(' + response.large_url + ')'
          });
          $('.js-preview').attr('data-image-id', response.id);
          $('.js-loader').hide();
          $('.js-loader').removeClass('animated');
          new Alert().success();
        },
        error: function error(_error7) {
          console.log(_error7);
          $('.js-loader').hide();
          $('.js-loader').removeClass('animated');
          new Alert().warning();
        }
      });
    });
    var that = $(this);
    that.on('submit', function (e) {
      e.preventDefault();

      if ($(this).hasClass('js-create-article')) {
        var urlApi = '/api/v1/articles';
        var method = 'POST';
      } else {
        var urlApi = '/api/v1/articles/' + $('.js-article').attr('data-id');
        var method = 'PUT';
      }

      var date_start = $('#event_date_start').val(),
          time_start = $('#start_hour').val();
      var date_end = $('#event_date_end').val(),
          time_end = $('#end_hour').val();

      if ($('#event_date_start').val()) {
        var event_date_start = date_start + 'T' + time_start;
      } else {
        var event_date_start = null;
      }

      if ($('#event_date_end').val()) {
        var event_date_end = date_end + 'T' + time_end;
      } else {
        var event_date_end = null;
      }

      var groupsArr = [];
      $('.js-groups-checkboxes').each(function () {
        if ($(this).prop('checked') || $(this).prop('disabled')) {
          groupsArr.push(parseInt($(this).val()));
        }
      });
      var tags = [];
      $('.js-tag').each(function () {
        var tag_value = $(this).find('.js-tag-value').text();
        tags.push(tag_value);
      });
      var dataToSend = {
        "title": $('#title').val(),
        "image": $('.js-preview').data('image-id'),
        "published_date": $('#published_date').val(),
        "is_published": $('#publish').prop('checked'),
        "is_public": vueEditArticle.article.is_public,
        "is_private": vueEditArticle.article.is_private,
        "is_event": $('#event').prop('checked'),
        "location": $('#location').val(),
        "event_date_start": event_date_start,
        "event_date_end": event_date_end,
        "event_location": $('#event_location').val(),
        "tags": tags,
        "category": vueEditArticle.article.category,
        "content": CKEDITOR.instances['content'].getData(),
        "author": $('#author').val(),
        "video_id": vueEditArticle.videoURL ? $('#video').data('video-id') : '',
        "groups": groupsArr
      };
      console.log(vueEditArticle.videoURL);
      $.ajax({
        url: urlApi,
        type: method,
        data: JSON.stringify(dataToSend),
        cache: false,
        contentType: 'application/json',
        processData: false,
        headers: {
          'Accept-Language': languageCode
        },
        // beforeSend: (xhr) => { xhr.setRequestHeader('Accept-Language', languageCode); },
        success: function success(response) {
          $('.js-notification').addClass('show');
          setTimeout(function () {
            $('.js-notification').removeClass('show');
          }, 1500);

          if (that.hasClass('js-create-article')) {
            setTimeout(function () {
              window.location.replace(that.data('success'));
            }, 2000);
          } else {
            $('.js-form-article').unbind('submit');
            $('.js-form-article').removeClass('js-create-article');
            $('.js-article').attr('data-id', response.id);
            $('.js-form-article').updateArticle();
          }
        },
        error: function error(_error8) {
          console.log(_error8);
          var errors = _error8.responseJSON;
          new Alert().error();

          for (_error8 in errors) {
            $('[data-error="' + _error8 + '"]').addClass('has-error');
          }
        }
      });
    });
  };
})(jQuery);

function inputTags() {
  var tags = $('.js-tag-value');
  var data = [];
  tags.each(function () {
    data.push($(this).text());
  });
  $('#tags').attr('data-tags', JSON.stringify(data));
}

(function ($) {
  $.fn.addTag = function () {
    var that = $(this);
    that.on('click', function (e) {
      e.preventDefault();
      var inputText = $(this).prev().val();
      var tag = '<div class="tag js-tag">' + '<p class="js-tag-value">' + inputText + '</p>' + '<div class="close js-close">' + '<img src="/static/svg/private/close-icon.svg" title="Delete">' + '</div>' + '</div>';
      $(this).prev().val('');

      if (inputText != '') {
        $('.js-tags').append(tag);
      }

      $('.js-tag').find('.js-close').removeTag();
      inputTags();
    });
  };
})(jQuery);

(function ($) {
  $.fn.removeTag = function () {
    var that = $(this);
    that.on('click', function (e) {
      e.preventDefault();
      console.log($(this));
      $(this).parent().remove();
    });
  };
})(jQuery);

(function ($) {
  $.fn.chooseCategory = function () {
    var that = $(this),
        input = $('#category_article');
    that.each(function () {
      if ($(this).val() == input.val()) {
        $(this).prop('checked', true);
      }
    });
    that.on('change', function () {
      input.val($(this).val());
    });
  };
})(jQuery);

(function ($) {
  $.fn.initGroupsArticles = function () {
    var groups = $('.js-article-groups');
    var arrGroups = [];
    groups.each(function () {
      arrGroups.push(parseInt($(this).attr('id')));
    });
    $('.js-groups-checkboxes').each(function () {
      if ($(this).prop('disabled') == false) {
        for (var i = 0; i < arrGroups.length; i++) {
          if ($(this).attr('id') == arrGroups[i]) {
            $(this).prop('checked', true);
          }
        }
      }
    });
  };
})(jQuery);

(function ($) {
  $.fn.initAttachment = function () {
    $(this).on('submit', function (e) {
      var that = this;
      e.preventDefault();

      if (!that.classList.contains('form-is-updating')) {
        that.classList.add('form-is-updating');
        var formData = new FormData($(this)[0]); // Téléchargement

        if ($(this).find('.js-tab-toggle.active').attr('data-target') == 1) {
          formData.append('title', $('#attachment_title').val());
          formData.append('file', $('#uploadAttachment').find('.js-attachment-input')[0].files[0]);
        } // Lien url


        if ($(this).find('.js-tab-toggle.active').attr('data-target') == 2) {
          formData.append('title', $('#attachment_video_title').val());
          formData.append('video_id', $('#attachment_video_url').val());
        }

        formData.append('rubric', 2);
        formData.append('file_type', parseInt($('#type_attachment').find('option:selected').data('id')));
        formData.append('content_type', parseInt($('.js-article').data('content-type')));
        formData.append('object_id', parseInt($('.js-article').data('id')));

        if ($(this).hasClass('js-form-create-upload')) {
          var date_start = $('#event_date_start').val(),
              time_start = $('#start_hour').val(),
              event_date_start = date_start + 'T' + time_start;
          var date_end = $('#event_date_end').val(),
              time_end = $('#end_hour').val(),
              event_date_end = date_end + 'T' + time_end;

          if ($('#event').prop('checked') == false) {
            event_date_start = null;
            event_date_end = null;
          }

          var groupsArr = [];
          $('.js-groups-checkboxes').each(function () {
            if ($(this).prop('checked') || $(this).prop('disabled')) {
              groupsArr.push(parseInt($(this).val()));
            }
          });
          var tags = [];
          $('.js-tag').each(function () {
            var tag_value = $(this).find('.js-tag-value').text();
            tags.push(tag_value);
          });
          var dataToSend = {
            "title": $('#title').val(),
            "image": $('.js-preview').data('image-id'),
            "published_date": $('#published_date').val(),
            "is_published": $('#publish').prop('checked'),
            "is_public": vueEditArticle.article.is_public,
            "is_private": vueEditArticle.article.is_private,
            "is_event": $('#event').prop('checked'),
            "location": $('#location').val(),
            "event_date_start": event_date_start,
            "event_date_end": event_date_end,
            "event_location": $('#event_location').val(),
            "tags": tags,
            "category": vueEditArticle.article.category,
            "content": CKEDITOR.instances['content'].getData(),
            "author": $('#author').val(),
            "video_id": vueEditArticle.videoURL ? $('#video').data('video-id') : null,
            "groups": groupsArr
          };
          console.log(dataToSend.video_id); // $.ajax({
          //     url: '/api/v1/articles',
          //     type: 'POST',
          //     data: JSON.stringify(dataToSend),
          //     cache: false,
          //     contentType: 'application/json',
          //     processData: false,
          //     success: function(response) {
          //         console.log(response);
          //         formData.append('object_id', response.id);
          //         $('.js-form-article').unbind('submit');
          //         $('.js-form-article').removeClass('js-create-article');
          //         $('.js-form-upload').removeClass('js-form-create-upload');
          //         $('.js-article').attr('data-id', response.id);
          //         $('[data-error]').removeClass('has-error');
          //         setTimeout(function(){
          //             $('.js-form-article').updateArticle();
          //         }, 500)
          //     },
          //     error: function(error) {
          //         console.log(error);
          //         var errors = error.responseJSON;
          //         new Alert().error();
          //         for(error in errors) {
          //             $('[data-error="'+ error +'"]').addClass('has-error');
          //         }
          //     }
          // });
        } else {
          formData.append('object_id', parseInt($('.js-article').attr('data-id')));
        }

        setTimeout(function () {
          $.ajax({
            url: '/api/v1/attachments',
            type: 'POST',
            data: formData,
            contentType: false,
            processData: false,
            success: function success(response) {
              that.classList.remove('form-is-updating');
              $('#uploadAttachment').removeClass('is-open');
              $('.js-modal-error').hide();
              var wrapper = $('.js-attachments-wrapper');
              var div = '<div class="col-lg-6">' + '<div class="attachment-edit">' + '<p>' + response.title + '</p>' + '<div class="close js-delete-attachment" data-id="' + response.id + '"><img src="/static/svg/private/close-icon.svg" title="Delete"></div>' + '</div>' + '</div>';
              wrapper.append(div);
              vueEditArticle.deleteAttachment();
              new Alert().success();
              $(".js-form-upload").unbind('submit');
              return false;
            },
            error: function error(_error9) {
              // console.log(error);
              var errorText = _error9.responseJSON.file[0];
              var errors = _error9.responseJSON;

              for (_error9 in errors) {
                $('.js-form-upload').find('.js-tab-item.active').find('[data-error="' + _error9 + '"]').addClass('has-error');
              }

              console.log(errorText);
              $('.js-modal-error').text(errorText);
              $('.js-modal-error').show();
            }
          });
        }, 1000);
      }
    });
  };
})(jQuery);
/*$(function(){
  if ($('.js-form-article').length) {
    $('.js-form-article').updateArticle();
  }
   if ($('.js-btn-tags').length) {
    $('.js-btn-tags').addTag();
  }
   if ($('.js-tag').length) {
    $('.js-tag').find('.js-close').removeTag();
  }
    if ($('.js-add-attachment-article').length) {
    $('.js-form-upload').initAttachment();
     $('.js-add-attachment-article').on('click', function() {
      vueEditArticle.addAttachment();
      vueEditArticle.typeAttachment();
    })
  }
});*/